import { Features } from '@lessonPlanner/constants';

export const LOCAL_CURRICULUM_FEATURES = [
  Features.LESSON_PLAN,
  Features.OBJECTIVES,
  Features.DLL,
  Features.SUMMATIVE_TEST,
  Features.SUBJECT_EXTENSIONS,
  Features.QUIZMAKER,
  Features.ACTIVITIES,
  Features.CATCH_UP_FRIDAYS,
  Features.ANALOGY,
  Features.GENERIC_UNPACKING,
  Features.IPLAN_OBJECTIVES,
  Features.MULTIGRADE_LESSON_PLAN,
] as Features[];

export const INTERNATIONAL_CURRICULUM_FEATURES = [
  Features.UNIT_PLAN,
  Features.SUMMATIVE_TEST,
] as Features[];

export const USA_CURRICULUM_FEATURES = [
  Features.LESSON_PLAN,
  // Features.OBJECTIVES,
  Features.ACTIVITIES,
  Features.QUIZMAKER,
  Features.SUMMATIVE_TEST,
] as Features[];

// export const MONTESSORI_CURRICULUM_FEATURES = [
//   Features.LESSON_PLAN,
//   Features.SUMMATIVE_TEST,
// ] as Features[];

export const DEFAULT_CURRICULUM_FEATURES = [
  Features.LESSON_PLAN,
  Features.OBJECTIVES,
  Features.ACTIVITIES,
  Features.QUIZMAKER,
] as Features[];

export const NON_CURRICULUM_SPECIFIC_FEATURES = [
  Features.TOPIC_EXPLORER,
  Features.ENERGIZER,
  Features.ELIF,
  Features.PHOTO_BOOTH,
  Features.PPT_MAKER,
] as Features[];
